module.exports = __webpack_public_path__ + "images/rich_heading/sports/fitness/icon_07816b9a8952d00a363e4b45b8e950de.png";